import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types, Creators } = createActions({
  productDetailInit: [],
  productDetailRequest: [],
  productDetailSuccess: ['data'],
  productDetailError: ['err'],
  getProductsDetail: ['filter'],
  productDetailSortBy: ['data', 'sort'],
  productDetailExpand: ['expandedRow'],
  productDetailInitTable: []
});

/** --------------------------------
 * Variable declarations
 * --------------------------------- */

const INITIAL_STATE = Immutable({
  data: [],
  sort: { produto: { value: 'produto', order: 'asc' } },
  defaultData: [],
  error: false,
  loading: false,
  expandedRow: null
});

/* Reducers Table */

export const init = state => state.merge({ ...INITIAL_STATE });

export const request = state => state.merge({ loading: true });

export const success = (state, { data }) => state.merge({ data, defaultData: data, error: false, loading: false, sort: INITIAL_STATE.sort });

export const error = state => state.merge({ loading: false, error: true });

export const sortBy = (state, { data, sort }) => state.merge({ data, sort, expandedRow: null });

export const expand = (state, { expandedRow }) => state.merge({ expandedRow });

export const initTable = state => state.merge({ sort: INITIAL_STATE.sort, expandedRow: null });

/* Reducers to types */

export default createReducer(INITIAL_STATE, {
  [Types.PRODUCT_DETAIL_INIT]: init,
  [Types.PRODUCT_DETAIL_REQUEST]: request,
  [Types.PRODUCT_DETAIL_SUCCESS]: success,
  [Types.PRODUCT_DETAIL_ERROR]: error,
  [Types.PRODUCT_DETAIL_SORT_BY]: sortBy,
  [Types.PRODUCT_DETAIL_EXPAND]: expand,
  [Types.PRODUCT_DETAIL_INIT_TABLE]: initTable
});